import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { AdiantamentoFolha } from 'src/app/admihair/api/dto/adiantamento-folha';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { AdiantamentoFolhaService } from 'src/app/admihair/service/adiantamento-folha.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { AdmihairBaseComponent } from '../../../admihair-base.component';

@Component({
  selector: 'app-adiantamento-listar',
  templateUrl: './adiantamento-listar.component.html',
  styleUrls: ['./adiantamento-listar.component.scss']
})
export class AdiantamentoListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loading: boolean = false;
  empresaSelecionada?: Empresa;
  adiantamentos: AdiantamentoFolha[] = [];
  filtroMes: SelectItem[] = [
    { label: 'Janeiro', value: 1 },
    { label: 'Fevereiro', value: 2 },
    { label: 'Março', value: 3 },
    { label: 'Abril', value: 4 },
    { label: 'Maio', value: 5 },
    { label: 'Junho', value: 6 },
    { label: 'Julho', value: 7 },
    { label: 'Agosto', value: 8 },
    { label: 'Setembro', value: 9 },
    { label: 'Outubro', value: 10 },
    { label: 'Novembro', value: 11 },
    { label: 'Dezembro', value: 12 }
  ];
  filtroAno: number[] = [2022, 2023, 2024];
  anoSelecionado: number = new Date().getFullYear();
  mesSelecionado: number = new Date().getMonth() + 1;
  filtroDataTransacao?: Date;

  constructor(private adiantamentoFolhaService: AdiantamentoFolhaService,

    private confirmationService: ConfirmationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    utilStorageService: UtilStorageService,) {
    super(erroService, utilStorageService)
  }



  ngOnInit(): void {
    this.loading = true;
    this.verificarPermissoes();
    this.empresaSelecionada = this.getEmpresa();
    this.inicializarCompetenciaAtual();
    if (this.permissaoListar) {
      this.carregarAdiantamentos();
    }
  }

  inicializarCompetenciaAtual() {
    const now = new Date()
    this.filtroDataTransacao = new Date(now.getFullYear(), now.getMonth(), 1);
  }

  carregarAdiantamentos() {
    this.loading = true;
    this.adiantamentoFolhaService.listarPorEmpresaIdComFiltros(this.empresaSelecionada?.id, this.filtroDataTransacao)
      .subscribe({
        next: (data: AdiantamentoFolha[]) => {
          this.loading = false;
          this.adiantamentos = data;
        },
        error: (err: any) => {
          this.loading = false;
          this.exibirMensagemErro(err);
        }
      })
  }


  excluir(id: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.adiantamentoFolhaService.excluir(id).subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            this.carregarAdiantamentos();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });

      }
    });
  }


  editar(id: number) {
    this._router.navigate(["/apps/adiantamento/editar/" + id], { relativeTo: this._activatedRoute })
  }

  detalhar(id: number) {
    this._router.navigate(["/apps/adiantamento/detalhar/" + id], { relativeTo: this._activatedRoute })
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_ADIANTAMENTO_FOLHA');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_ADIANTAMENTO_FOLHA');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_ADIANTAMENTO_FOLHA');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_ADIANTAMENTO_FOLHA');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_ADIANTAMENTO_FOLHA');
  }

}
